/**
 * AuthGuard — 路由守卫组件
 * - 未登录用户重定向到登录页（携带来源路径，登录后可跳回）
 * - 支持 roles 属性进行角色权限校验（如 admin 页面）
 * - 角色不匹配时重定向到首页
 */
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/useAuthStore";

interface Props {
  children: React.ReactNode;
  /** 允许访问的角色列表，不传则仅校验登录状态 */
  roles?: string[];
}

const AuthGuard: React.FC<Props> = ({ children, roles }) => {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  // 未登录 → 跳转登录页，记录来源路径
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // 角色不匹配 → 跳转首页
  if (roles && user && !roles.some((role) => user.roles.includes(role))) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
